import React from 'react'
import './index.less'
import { SRC_URL } from '@/server'

export default function Imitation(props) {
  const { similarImgsInfo } = props
  console.log(similarImgsInfo, 'similarImgsInfo')

  return (
    <div className='imitation-wrapper'>
      {/* TODO:imgsrc */}
      {similarImgsInfo.slice(0, 3).map((item) => {
        return (
          <div className='imitation-each' key={item.title}>
            <img
              className='imitation-pic'
              src={item.imgSrc ? SRC_URL + item.imgSrc : ''}
              alt=''
            ></img>
            <div className='imitation-txt'>
              <div className='imitation-txt-name'>{item.title}</div>
              <div className='imitation-txt-percent'>{item.similarity + '%'}</div>
            </div>
            <div className='imitation-txt-dynasty'>
              {item.dynasty}/{item.author}
            </div>
          </div>
        )
      })}
    </div>
  )
}
